import React from "react";
import { Link } from "react-router-dom";

function Dmteam() {
  const team = [
    {
      name: "Razak",
      role: "Digital Marketing Expert",
      image: "razak.png",
    },
    {
      name: "Sahakkel",
      role: "UI/UX Developer",
      image: "shakeel.png",
    },
  ];

  return (
    <section className="relative py-16 px-6 lg:px-16 overflow-hidden bg-[#f8f8f8] dark:bg-[#050505]">
      {/* Glow Background */}
      <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-primary/10 blur-[140px] rounded-full" />
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-orange-300/10 blur-[140px] rounded-full" />

      {/* Grid BG */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(0,0,0,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(0,0,0,0.03)_1px,transparent_1px)] dark:bg-[linear-gradient(rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.03)_1px,transparent_1px)] bg-[size:70px_70px]" />

      <div className="relative z-10 max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-12 gap-10 items-start">
        {/* LEFT SIDE */}
        <div className="md:col-span-6">
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 dark:text-white leading-tight">
            Meet Our Expert{" "}
            <span className="inline bg-gradient-to-r from-primary via-orange-400 to-yellow-400 bg-clip-text text-transparent">
              Team Leaders
            </span>
          </h2>

          <p className="mt-4 text-gray-600 dark:text-gray-400">
            We build performance-driven digital experiences with a team of
            experts in marketing, design, and development.
          </p>

          <div className="mt-6">
            <ul className="space-y-3 text-gray-700 dark:text-gray-300">
              <li className="flex gap-2">
                <span className="text-primary">•</span>2 expert consultants
                working with us
              </li>
              <li className="flex gap-2">
                <span className="text-primary">•</span>
                4-person dedicated digital marketing team
              </li>
              <li className="flex gap-2">
                <span className="text-primary">•</span>
                7+ freelance professionals across domains
              </li>
            </ul>
          </div>
          <div className="mt-10 flex items-center gap-4">
            <div className="text-sm text-gray-500 dark:text-gray-400">
              Certified Digital Marketing Professional
            </div>
            <div className="w-24 h-[3px] bg-primary rounded-full" />
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="md:col-span-6 grid grid-cols-1 md:grid-cols-2 gap-6">
          {team.map((member, index) => (
            <div
              key={index}
              className="h-[360px] relative rounded-2xl overflow-hidden group border border-gray-200/40 dark:border-white/10 shadow-lg"
            >
              <img
                src={member.image}
                className="w-full h-full object-cover group-hover:scale-110 transition duration-700"
                alt={member.name}
              />

              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />

              <div className="absolute bottom-0 left-0 p-6 text-white">
                <h3 className="text-xl font-bold">{member.name}</h3>
                <p className="text-sm text-white/70">{member.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Dmteam;
